import { http } from "@/core/api/";

const apiUrl = "api/questionnairesample";

export const getQuestionnaireSamples = async params =>
  await http.get(`${apiUrl}/search`, { params });

export const getQuestionnaireFilterOptions = async () =>
  await http.get(`${apiUrl}/initfilters`);
